import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { MessageService } from 'primeng';
import { TaskType } from '../enums/task.type';
import { OrderLimitTypeEnum } from '../enums/order-limit-type.enum';
import { DayColor } from '../modules/driver-experience/app-full-calendar/app-full-calendar.component';

export interface DailyMovementLimit {
  drivenLimit: number;
  transportedLimit: number;
  drivenTotal: number;
  transportedTotal: number;
}

export interface DailyMovementLimitForTaskType {
  limit: number;
  total: number;
}

export interface DailyMovementLimitResult {
  global: DailyMovementLimit;
  customer: DailyMovementLimit;
  date: string;
}

export interface DailyMovementLimitResultForTaskType {
  global: DailyMovementLimitForTaskType;
  customer: DailyMovementLimitForTaskType;
  date: string;
}

@Injectable({ providedIn: 'root' })
export class DailyMovementLimitService {
  constructor(
    private http: HttpClient,
    private handlersFactory: HttpResponsesHandlersFactory,
    private messageService: MessageService,
  ) {}

  public save(value: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
    return this.http.post<any>('/api/movement-limits', value, { headers }).toPromise();
  }

  public getDailyMovementLimits(customerId: number = null): Promise<DailyMovementLimitResult[]> {
    return customerId == null
      ? this.http.get<DailyMovementLimitResult[]>('/api/movement-limits').toPromise()
      : this.http.get<DailyMovementLimitResult[]>(`/api/movement-limits/${customerId}`).toPromise();
  }

  public getDailyMovementLimitsForTaskType(
    taskType: TaskType,
    customerId: number = null,
  ): Promise<DailyMovementLimitResultForTaskType[]> {
    return customerId == null
      ? this.http
          .get<DailyMovementLimitResultForTaskType[]>(
            `/api/movement-limits/for-task-type/${taskType}`,
          )
          .toPromise()
      : this.http
          .get<DailyMovementLimitResultForTaskType[]>(
            `/api/movement-limits/for-task-type/${customerId}/${taskType}`,
          )
          .toPromise();
  }

  public getDayColors(
    moveLimits: DailyMovementLimitResult[],
    type: OrderLimitTypeEnum,
    customer = null,
  ): DayColor[] {
    let dc = moveLimits.map((r) => {
      let dayBlocked =
        (type === OrderLimitTypeEnum.Driven &&
          r.global.drivenLimit &&
          r.global.drivenTotal >= r.global.drivenLimit) ||
        (type === OrderLimitTypeEnum.Transported &&
          r.global.transportedLimit &&
          r.global.transportedTotal >= r.global.transportedLimit);

      if (!dayBlocked && customer) {
        dayBlocked =
          (type === OrderLimitTypeEnum.Driven &&
            r.customer.drivenLimit &&
            r.customer.drivenTotal >= r.customer.drivenLimit) ||
          (type === OrderLimitTypeEnum.Transported &&
            r.customer.transportedLimit &&
            r.customer.transportedTotal >= r.customer.transportedLimit);
      }

      if (dayBlocked) {
        return {
          date: r.date,
          bgColor: '#eb4034',
        };
      }
    });

    return dc.filter((r) => !!r);
  }
}
